<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement">
<h1>Acknowledgement</h1>
<p>I would like to thank my publishers at Austin Macauley, for their belief and assistance in bringing this book into your hands.</p>
<br/>
<p style="text-indent:0em;">To Bronwyn Simpson who acted as a ghostwriter, and now a friend whose dedication commitment, honesty, and reflection went a long way to making this book a reality.</p>
<br/>
<p style="text-indent:0em;">Lastly, and greatly, to make my steadfast partner and helpmate who has always encouraged me even when not quite sure of the sometimes ‘spooky’ path I’m happily skipping down.</p>
<br/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?71987dea